module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.mainView.loadingIndicator":"We are currently importing usage for this tenant.","views.mainView.loadFailedText":"There was an error loading your tenant status. Please refresh to continue.","views.mainView.invalidCredentialAlert":"Please check the following credential: "}}')
  delete Component.options._Ctor
}
